// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"8e1d7f7f","513":"22f42055","703":"25607e73","787":"a72d4ae2"}[chunkId] + ".chunk.js";
};